import { render, staticRenderFns } from "./ElementsPage.vue?vue&type=template&id=14978715"
import script from "./ElementsPage.vue?vue&type=script&lang=js"
export * from "./ElementsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports